<template>
    <!-- <v-parallax src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"> -->
  
  
      <div class="mx-1 my-1">
        <v-btn style="font-size: 11px;" class="ma-2" color="black" variant="outlined" disabled>VER<v-icon color="cyan" end icon="mdi-eye" disabled></v-icon></v-btn>
      <v-btn style="font-size: 11px;" class="ma-2" color="black" variant="outlined" disabled>Reg. RESARCIMIENTO SABLES Y ESPADAS<v-icon color="red" end icon="mdi-sword-cross" disabled></v-icon></v-btn>
        <v-card>
          <v-alert v-if="showAlert" type="success" title="Registrado !!!"
            text="Se ha registrado correctamente el Repuesto Cuchillo.">
            <v-icon @click="cerrarDialogo" class="m-1 position-absolute top-0 end-0" color="blue-lighten-5"
              icon="mdi-close-circle"></v-icon>
          </v-alert>
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" color="light-blue-darken-4" label="Buscar" single-line
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="registros" :search="search">
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon class="m-1"
                  color="light-blue-lighten-2" @click="abrirDialogo(item)" icon="mdi-eye">
                </v-icon>
                <!-- <v-icon @click="abrirDialogo2(item)" class="m-1"
                  color="blue-darken-2" icon="mdi-plus-box-multiple">
                </v-icon> -->
                  <v-icon @click="abrirDialogo3(item)" class="m-1" color="red-lighten-1" icon="mdi-sword-cross">
                  </v-icon>  
            </template>
          </v-data-table>
        </v-card>
        <v-dialog v-model="dialogoAbierto" max-width="500px">
          <v-card>
            <v-card-title> Contenido Individual </v-card-title>
            <v-card-text>
              <div><strong>ID: </strong> {{ codigo_dotacion_sec }}</div>
              <div><strong>NOMBRE_COMPLETO: </strong> {{ nombre_completo }}</div>
              <div><strong>CARNET: </strong> {{ carnet }}</div>
              <div><strong>DESCRIPCION: </strong> {{ descripcion }}</div>
              <div><strong>GESTION DOTACION: </strong> {{ gestion_dotacion }}</div>
              <div><strong>PROCEDENCIA: </strong> {{ procedencia }}</div>
              <div><strong>OBSERVACIONES: </strong> {{ observaciones }}</div>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="cerrarDialogo">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOGO DE RESARCIMIENTO -->
        <v-dialog v-model="dialogoAbiertoResarcimiento" max-width="750px">
          <v-card>
            <v-card-title class="text-center"> REGISTRO RESARCIMIENTO SABLE </v-card-title>
            <v-card-text>
              <!-- Formulario para editar el nombre -->
              <v-form @submit.prevent="registraresarcimiento">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="carnet" label="Carnet" :rules="firstNameRules" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="codigo_persona" label="Codigo Persona" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
  
                  <v-col cols="12" md="6">
                    <v-text-field v-model="codigo_dotacion" label="Codigo Dotacion" :rules="lastNameRules"
                      disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="descripcion" label="DESCRIPCION" :rules="lastNameRules" required></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="ornamento" label="ORNAMENTO" :rules="lastNameRules" required></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="vaina" label="VAINA" :rules="lastNameRules" required></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select v-model="gestion_dotacion" :items="gestiones" :item-value="gestion_dotacion"
                      label="Gestion Dotacion"></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="procedencia" label="INDUSTRIA" :rules="lastNameRules" required></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field v-model="observaciones" label="Observaciones" :rules="lastNameRules"
                      required></v-text-field>
                  </v-col>
                </v-row>
                <v-btn type="submit" block class="mt-2">Guardar Cambios</v-btn>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn variant="outlined" color="red" text @click="cerrarDialogo">Cerrar</v-btn>
            </v-card-actions>
  
          </v-card>
  
        </v-dialog>
  
      </div>
    <!-- </v-parallax> -->
  </template>
    
  <script>
  import { defineComponent } from "vue";
  //import ReposicionesLista from "@/services/Reposiciones";
  import ResarcimientosLista from "@/services/Resarcimientos";
  import { VDataTable } from "vuetify/labs/VDataTable";
  import Reposiciones from "@/services/Reposiciones";
  import ResarcimientoRegistro from "@/services/Resarcimientos";
  
  export default defineComponent({
    name: "AdminPage",
    components: {
      VDataTable,
    },
    data() {
      var registros;
      //const personal = new ReposicionesLista();
      const personal = new ResarcimientosLista();
      return {  
        carnet: "",
        codigo_persona: "",
        nro_cuchillo: "",
        marca: "",
        modelo: "",
        gestion_dotacion: "",
        procedencia: "",
        observaciones: "",
        gestiones: ["2023", "2024", "2025", "2026", "2027", "2028"],
        registros,
        personal,
        search: "",
        headers: [
          {
            align: "center",
            key: "name",
            sortable: true,
          },
          //{ key: 'codigo_dotacion', title: 'Codigo Dotacion' },
          { key: "grado", title: "Grado" },
          { key: "nombre_completo", title: "Nombre Completo" },
          { key: "carnet", title: "Carnet" },
          { key: "descripcion", title: "Descripcion" },
          { key: "gestion_dotacion", title: "Gestion Dotacion" },
          { key: "actions", title: "Acciones", sortable: true, width: 150 },
        ],
        dialogoAbierto: false,
        dialogoAbiertoRegistrar: false,
        dialogoAbiertoResarcimiento: false,
        showAlert: false,
        procedenciaList: [],
      };
    },
    methods: {
      cerrarDialogo() {
        this.dialogoAbierto = false;
        this.dialogoAbiertoRegistrar = false;
        this.dialogoAbiertoResarcimiento = false;
        this.showAlert = false;
      },
      //PARA EL ICONO DE VER
      abrirDialogo(item) {
        if (item && item.codigo_dotacion_sec) {
          this.codigo_dotacion_sec = item.codigo_dotacion_sec;
          this.carnet = item.carnet;
          this.nombre_completo = item.nombre_completo;
          this.codigo_persona = item.codigo_persona;
          this.descripcion = item.descripcion;
          this.marca = item.marca;
          this.modelo = item.modelo;
          this.gestion_dotacion = item.gestion_dotacion;
          this.procedencia = item.procedencia;
          this.observaciones = item.observaciones;
          this.dialogoAbierto = true;
          this.dialogoAbiertoregistrar = true;
        }
      },
/*       abrirDialogo2(item) {
        if (item && item.codigo_dotacion) {
          this.codigo_dotacion = item.codigo_dotacion;
          this.carnet = item.carnet;
          this.nombre_completo = item.nombre_completo;
          this.codigo_persona = item.codigo_persona;
          this.nro_cuchillo = item.nro_cuchillo;
          this.marca = item.marca;
          this.modelo = item.modelo;
          this.gestion_dotacion = item.gestion_dotacion;
          this.procedencia = item.procedencia;
          this.observaciones = item.observaciones;
          this.dialogoAbiertoRegistrar = true;
        }
      }, */
      //DATOS DEL RESARCIMIENTO SABLE
      abrirDialogo3(item) {
        if (item && item.codigo_dotacion) {
          this.codigo_dotacion = item.codigo_dotacion;
          this.carnet = item.carnet;
          this.nombre_completo = item.nombre_completo;
          this.codigo_persona = item.codigo_persona;
          this.descripcion = item.descripcion;
          this.ornamento = item.ornamento;
          this.vaina = item.vaina;
          this.gestion_dotacion = item.gestion_dotacion;
          this.procedencia = item.procedencia;
          this.observaciones = item.observaciones;
          this.dialogoAbiertoResarcimiento = true;
        }
      },
      async registraresarcimiento() {
        try {
          const resarcimiento = new ResarcimientoRegistro();
          const cuchillopost = {
            carnet: this.carnet,
            codigo_persona: this.codigo_persona,
            codigo_dotacion: this.codigo_dotacion,
            descripcion: this.descripcion,
            ornamento: this.ornamento,
            vaina: this.vaina,
            gestion_dotacion: this.gestion_dotacion,
            procedencia: this.procedencia,
            observaciones: this.observaciones,
          };
          const response = await resarcimiento.saveSableResarcimiento(
            cuchillopost
          );
          if (response.status === true) {
            console.log("Datos guardados exitosamente:", response);
            this.cerrarDialogo();
            this.showAlert = true;
          } else {
            console.error("Error al guardar los datos:", response);
            this.cerrarDialogo();
          }
        } catch (error) {
          console.error("Error en la función submitForm:", error);
        }
      },
      async submitForm() {
        try {
          const reposicioncuchillo = new Reposiciones();
          const cuchillopost = {
            carnet: this.carnet,
            codigo_persona: this.codigo_persona,
            nro_cuchillo: this.nro_cuchillo,
            marca: this.marca,
            modelo: this.modelo,
            gestion_dotacion: this.gestion_dotacion,
            procedencia: this.procedencia,
            observaciones: this.observaciones,
          };
  
          const response = await reposicioncuchillo.savePistolaReposicion(
            cuchillopost
          );
          if (response.status === true) {
            console.log("Datos guardados exitosamente:", response);
            //this.showAlert = true;
            //this.limpiarFormulario();
            this.cerrarDialogo();
            this.showAlert = true;
            //alert("El dato se registro correctamente");
            /* setTimeout(() => {
              this.showAlert = false;
            }, 1400); */
          } else {
            console.error("Error al guardar los datos:", response);
            this.cerrarDialogo();
          }
        } catch (error) {
          console.error("Error en la función submitForm:", error);
        }
      },
    },
  
    async created() {
      this.registros = await this.personal.listaresarcimientosableejercito();
      //this.procedenciaList = await this.personal.listaprocedencia(this.procedencia);
    },
  });
  </script>
    